<template>
  <div class="addEmployeePersonalVue">
    <!-- HUGE COMMENT -->
    <!-- Please add autocomplete='off' to all input fields or at form level -->

    <div class="c-responsive-fixwidth">
         <div class="clearfix o-skillset-area">
             <form autocomplete="off">
                <div class="employer-info">
                 <div class="field-group">
                     <div class="row">
                         <div class="col-sm-4">
                             <div class="c-common-space c-common-box-shadow c-radius3">
                                 <div class="c-user-tab-content clearfix o-skillset-area">
                                     <div class="layout-table">
                                         <div class="layout-table-cell">
                                             <div class="form-group employerpic-upload-sec">
                                                 <div class="employerpic-upload">
                                                     <!-- <img src="static/assets/images/user1.png" alt="" id='img-upload'> -->
                                                     <img
                                                          :src="finalCropImg"
                                                          alt="Cropped Image"
                                                        />
                                                 </div>
                                                 <div class="employerpic-upload-btn o-upload-profile-btn">
                                                     <div class="input-group">
                                                         <span class="input-group-btn">
                                                             <span class="btn btn-default btn-file">
                                                                 <input type="file" id="imgInp" @change="addProfileImg($event)">
                                                             </span>
                                                         </span>
                                                         <input type="text" class="form-control" readonly>
                                                     </div>
                                                     <i class="fa fa-plus"></i>
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <div class="col-sm-8">
                             <div class="c-common-space c-common-box-shadow c-radius3">
                                 <div class="c-user-tab-content clearfix o-skillset-area">
                                     <p>Basic Info:</p>
                                     <div class="row">
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Nickname :<!-- <span class="req-text">*</span> --></label>
                                                  <!-- @blur="blur($event)" v-validate="'required'" -->
                                                 <input autocomplete="random" v-model="empPersonal.basicInfo.userName" @change="onUpdateInputField" name="userName" data-vv-delay="500" type="text" class="form-control" placeholder="User Name" >
                                                 <!-- <span v-show="errors.has('userName') && this.validation_err!=0" class="err-msg">{{ errors.first('userName') }}</span> -->
                                             </div>
                                         </div>
                                         <!-- <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Password:<span class="req-text">*</span></label>
                                                 <input autocomplete="random" @change="onUpdateInputField" @blur="blur($event)" name="password" v-model="empPersonal.basicInfo.password" data-vv-delay="500" type="password" class="form-control" placeholder="Password" v-validate="'required|min:6'">
                                                 <span class="err-msg">**REQUIRED FIELD: minimum 6 characters**</span>
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Confirm Password:<span class="req-text">*</span></label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.cnfPassword" type="password" class="form-control" placeholder="Repeat Password" v-validate="'required|confirmed:password'" @blur="blur($event)" name="cnfPassword" data-vv-delay="500">
                                                 <span class="err-msg">**REQUIRED FIELD**</span>
                                             </div>
                                         </div> -->
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">First Name:<span class="req-text">*</span></label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.firstName" type="tel" class="form-control o-capitalize-field" placeholder="First Name" v-validate="'required|alpha'" @blur="blur($event)" name="firstName" data-vv-delay="500">
                                                 <span class="err-msg">**REQUIRED FIELD**</span>
                                             </div>
                                         </div>
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Last Name:<span class="req-text">*</span></label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.basicInfo.lastName" type="tel" class="form-control o-capitalize-field" placeholder="Last Name" v-validate="'required|alpha'" @blur="blur($event)" name="lastName" data-vv-delay="500">
                                                 <span class="err-msg">**REQUIRED FIELD**</span>
                                                 <!-- <span v-show="errors.has('lastName') && this.validation_err!=0" class="err-msg">{{ errors.first('lastName') }}</span> -->
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>

                 <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="u-bg-color-fff c-common-space c-common-box-shadow c-radius3 ">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="c-user-tab-content clearfix o-skillset-area">
                                            <p>Email:</p>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text form-label">Primary Email:<span class="req-text">*</span></label>
                                                 
                                                        <input autocomplete="random" @keyup="customValEmail($event, empPersonal.contact.email)" v-model="empPersonal.contact.email" type="text" class="form-control" placeholder="Primary Email" v-validate="'email|required'" data-vv-as="email" @blur="blur($event)" name="email" data-vv-delay="500">
                                                        
                                                        <span v-show="errors.has('email')" class="err-msg">{{ errors.first('email') }}</span>

                                                        <span v-if="emailExistNote == 1 && !errors.has('email')" class="customExisticon o-customExisticon-tick">
                                                            <i class="fa fa-check" aria-hidden="true"></i>
                                                        </span>
                                                        <span v-else-if="emailExistNote == 0 || errors.has('email')" class="customExisticon o-customExisticon-cross">
                                                            <i class="fa fa-times" aria-hidden="true"></i>
                                                        </span>
                                                        <div class="o-customExisticon-cross" v-if="emailExistNote == 0">
                                                            <span>{{ $t('email_already_exist') }}</span>
                                                            <span>{{ $t('please_visit_faq') }}</span>
                                                            <br />
                                                            <a href="https://cs3.me/eae" target="_blank"> Faq - Email Exists </a>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">Secondary Email:</label>
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.secEmail" type="email" class="form-control" placeholder="Secondary Email">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div class="c-user-tab-content clearfix o-skillset-area">
                                            <p>Phone:</p>
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text  form-label">Home Phone:</label>
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.homePhone" v-validate="'digits|between:10,15'" @blur="blurHomePhone($event)" name="homePhone" type="tel" class="form-control" placeholder="Home phone number">
                                                        <!-- <span v-show="errors.has('homePhone') && this.validation_err!=0" class="err-msg">10 - 12 digits- Exclude all Dots and Dashes.</span> -->
                                                        <span v-show="errors.has('homePhone')" class="err-msg">Home Phone Must have minimum length of 10</span>
                                                        <!-- <span v-else class="err-msg">10 - 15 digits- Exclude all Dots, Spaces and Dashes.</span> -->
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text form-label">Cell Phone:<!-- <sup>*</sup> --></label>
                                                        <!-- v-validate="'required'" @blur="blur($event)"  -->
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.contact.cellPhone" v-validate="'required|digits|between:10,15'" @blur="blurCellPhone($event)" type="text" class="form-control" placeholder="Cell phone number" name="cellPhone" data-vv-delay="500">
                                                        <!-- <span v-show="errors.has('cellPhone') && this.validation_err!=0" class="err-msg">10 - 15 digits- Exclude all Dots and Dashes.</span> -->
                                                        <span v-if="errors.has('cellPhone')" class="err-msg">
                                                            Cell Phone Must have minimum length of 10
                                                        </span>
                                                        <span v-else class="err-msg"> 
                                                            REQUIRED, Exclude all Dots and Dashes.
                                                        </span>
                                                            <!-- <span v-else class="err-msg">10 - 15 digits- Exclude all Dots, Spaces and Dashes.</span> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="field-group">
                     <div class="row">
                         <div class="col-sm-12">
                             <div class="c-common-space c-common-box-shadow c-radius3">
                                 <div class="c-user-tab-content clearfix o-skillset-area">
                                     <p>Address:</p>
                                     <div class="row">
                                         <div class="col-sm-8">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Street Address:<!-- <sup>*</sup> --></label>                                 <!-- v-validate="'required'" @blur="blur($event)" -->
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.streetAdd" type="text" class="form-control o-capitalize-field" placeholder="Street Address" name="streetAdd" data-vv-delay="500">
                                                 <!-- <span v-show="errors.has('streetAdd') && this.validation_err!=0" class="err-msg">{{ errors.first('streetAdd') }}</span> -->
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">City:<!-- <sup>*</sup> --></label>
                                                 <!-- v-validate="'required'" @blur="blur($event)" -->
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.city" type="text" class="form-control o-capitalize-field" placeholder="City" v-validate="'required'" @blur="blur($event)" name="city" data-vv-delay="500">
                                                 <!-- <span v-show="errors.has('city') && this.validation_err!=0" class="err-msg">{{ errors.first('city') }}</span> -->
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">State:<!-- <sup>*</sup> --></label>
                                                 <!-- v-validate="'required'" @blur="blur($event)" -->
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.state" type="text" class="form-control o-capitalize-field" placeholder="State" name="state" data-vv-delay="500">
                                                 <!-- <span v-show="errors.has('state') && this.validation_err!=0" class="err-msg">{{ errors.first('state') }}</span> -->
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Zip:<!-- <sup>*</sup> --></label>
                                                <!-- v-validate="'required'" @blur="blur($event)" -->
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.address.zip" type="text" class="form-control" placeholder="Zip" name="zip" data-vv-delay="500">
                                                 <span class="err-msg">** Remove ALL Spaces,Dots,Dashes **</span>
                                                 <!-- <span v-show="errors.has('zip') && this.validation_err!=0" class="err-msg">{{ errors.first('zip') }}</span> -->
                                             </div>
                                         </div>
                                          <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text form-label">Country:<!-- <sup>*</sup> --></label>
                                                 <div class="o-cutsomSelect">
                                                    <select @change="onUpdateInputField" v-model="empPersonal.address.country" name="country" data-vv-delay="500">
                                                        <option value="">Country</option>
                                                        <option value="USA">USA</option>
                                                        <option value="Canada">Canada</option>
                                                        <option value="UK">UK</option>
                                                        <!-- <option value="India">India</option> -->
                                                    </select>
                                                    <!-- <span v-show="errors.has('country') && this.validation_err!=0" class="err-msg">{{ errors.first('country') }}</span> -->
                                                </div>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>

                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>PO Box Address:</p>
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <div class="form-group ">
                                                <label class="common-label-text">P.O. Box:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.pbAdd" type="text" class="form-control" placeholder="P.O. Box">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">City:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.city" type="text" class="form-control" placeholder="City">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">State:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.state" type="text" class="form-control" placeholder="State">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Zip:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.zip" type="text" class="form-control" placeholder="Zip">
                                                <span class="err-msg">** Remove ALL Spaces,Dots,Dashes **</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Country:</label>
                                               
                                                <div class="o-cutsomSelect">
                                                    <select @change="onUpdateInputField" v-model="empPersonal.PoBoxAddress.country" placeholder="Country">
                                                        <option value="">Country</option>
                                                        <option value="USA">USA</option>
                                                        <option value="UK">UK</option>
                                                        <option value="Canada">Canada</option>
                                                        <!-- <option value="India">India</option> -->
                                                    </select>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>Identity Fields( hashed and or encrypted) or outsourced:</p>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Driver’s License:</label>
                                                <input autocomplete="random" v-model="empPersonal.identityField.driverLicense" type="number" class="form-control" placeholder="Driver’s License">
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Social security:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.identityField.socialSecurity" type="text" class="form-control" placeholder="Social security">
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Mothers Maiden Name:</label>
                                                <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.identityField.monthMaidenName" type="text" class="form-control" placeholder="Mother’s maiden name">
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Date of Birth:</label>
                                                <!-- <input autocomplete="random" type="tel" class="form-control" placeholder="yyyyy-mm-dd"> -->
                                                <el-date-picker 
                                                 name="date"
                                                 @change="onUpdateInputField" 
                                                 v-model="empPersonal.identityField.dataOfBirth" 
                                                 v-validate="{ required: true}" 
                                                 type="date" 
                                                 :format="getDisplayFormat()" 
                                                 value-format="yyyy-MM-dd" 
                                                 :placeholder="getDatePlaceholder()" 
                                                 class="fullwidth-input">
                                                </el-date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field-group">
                     <div class="row">
                         <div class="col-sm-12">
                             <div class="c-common-space c-common-box-shadow c-radius3">
                                 <div class="c-user-tab-content clearfix o-skillset-area">
                                     <p>Emergency Card (admin, power user, job steward):</p>
                                     <div class="row">
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Contact Name:</label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.contactName" type="text" class="form-control" placeholder="Contact name">
                                             </div>
                                         </div>
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Contact Number:</label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.contactNuber" type="number" class="form-control" placeholder="Contact number">
                                             </div>
                                         </div>
                                         
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Home:</label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.homePhone" type="number" class="form-control" placeholder="Home phone number">
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Cell Number:</label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.cellPhone" type="number" class="form-control" placeholder="Cell phone number">
                                             </div>
                                         </div>
                                         <div class="col-sm-4">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Email ID:</label>
                                                 <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.emergency.email" type="email" class="form-control" placeholder="Email ID">
                                             </div>
                                         </div>
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Medical Conditions of Note:</label>
                                                 <textarea autocomplete="random" @change="onUpdateInputField" placeholder="Medical notes" class="form-control" rows="4" v-model="empPersonal.emergency.medicalCondition"></textarea>
                                             </div>
                                         </div>
                                         <div class="col-sm-6">
                                             <div class="form-group ">
                                                 <label class="common-label-text">Regular Medications:</label>
                                                 <textarea autocomplete="random" @change="onUpdateInputField" placeholder="Regular Medications" class="form-control" rows="4" v-model="empPersonal.emergency.regularMeication" ></textarea>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                </div>

                <div v-if="(custom_field_1 != '' && custom_field_1 != null) || (custom_field_2 != '' && custom_field_2 != null)" class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="u-bg-color-fff c-common-space c-common-box-shadow c-radius3 ">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="c-user-tab-content clearfix o-skillset-area">
                                            <p>Custom Fields:</p>
                                            <div class="row">
                                                <div v-if="custom_field_1 != '' && custom_field_1 != null" class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">{{custom_field_1}}:</label>
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.customFields.custom_field_1" type="text" class="form-control" :placeholder="custom_field_1">
                                                    </div>
                                                </div>
                                                <div v-if="custom_field_2 != '' && custom_field_2 != null" class="col-sm-6">
                                                    <div class="form-group ">
                                                        <label class="common-label-text">{{custom_field_2}}:</label>
                                                        <input autocomplete="random" @change="onUpdateInputField" v-model="empPersonal.customFields.custom_field_2" type="text" class="form-control" :placeholder="custom_field_2">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
             </form>
         </div>
    </div>

    <modal name="crop-image"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
         <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center o-small-modal-head">
                        <button @click="closeCropModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">Edit Image</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                        <div class="row">
                            <div class="col-sm-6">
                                 <div class="c-common-space c-radius3">
                                     <div class="c-user-tab-content clearfix o-skillset-area">
                                         <div class="layout-table">
                                             <div class="layout-table-cell">
                                                 <div class="employerpic-upload-sec">
                                                     <!-- <div class="employerpic-upload"> -->
                                                         <!-- <vue-cropper
                                                          ref="cropper"
                                                          :src="cropableImgPath"
                                                          alt="Source Image"
                                                        >
                                                        </vue-cropper> -->
                                                     <!-- </div> -->
                                                     <vue-cropper
                                                        ref="cropper"
                                                        :guides="true"
                                                        :view-mode="0"
                                                        drag-mode="crop"
                                                        :auto-crop-area="0.5"
                                                        :min-container-width="250"
                                                        :min-container-height="180"
                                                        :background="true"
                                                        :rotatable="true"
                                                        :src="cropableImg"
                                                        alt="Source Image"
                                                      >
                                                    </vue-cropper>

                                                        <!-- :img-style="{ width: '400px', height: '300px' }" -->
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                            </div>
                            <div class="col-sm-6">
                                 <div class="c-common-space c-radius3">
                                     <div class="c-user-tab-content clearfix o-skillset-area">
                                         <div class="layout-table">
                                             <div class="layout-table-cell">
                                                 <div class="employerpic-upload-sec">
                                                    <div>
                                                        <a href="javascript: void(0)" @click="cropImage()" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-crop" aria-hidden="true"></i> Crop</a>

                                                        <a href="javascript: void(0)" @click="rotate" v-if="cropableImg != ''" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-repeat" aria-hidden="true"></i> Rotate</a>
                                                    </div>
                                                    <div class="crop-image-top-margin">
                                                        <img
                                                          v-if="cropImg && cropImg!=''"
                                                          :src="cropImg"
                                                          style="width: 200px; border: 1px solid gray"
                                                          alt="Cropped Image"
                                                        />
                                                    </div>
                                                    
                                                    
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="completeEdit()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Done</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="closeCropModal()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>

  </div>
</template>

<script>
    import {
        bus
    } from '../../main';
    import {
        global
    } from '../../global.js';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';

    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
        props: {
            empPersonalData: {
                type: Object,
                required: true
            }
        },
        components: { 
            VueCropper
        },
        data() {
            return {

                cropImg:'',
                cropableImg:'',
                finalCropImg:'static/assets/images/user1.png',
                emailExistNote: -1,
                validation_err: 0,
                custom_field_1:'',
                custom_field_2:'',
                img_format:['jpg', 'jpeg', 'png', 'gif'],
                empPersonal: {
                    basicInfo: {
                        userName: '',
                        password: '',
                        cnfPassword: '',
                        firstName: '',
                        lastName: '',
                    },
                    address: {
                        streetAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    PoBoxAddress: {
                        pbAdd: '',
                        city: '',
                        state: '',
                        zip: '',
                        country: '',

                    },
                    contact: {
                        email: '',
                        secEmail: '',
                        homePhone: '',
                        cellPhone: '',
                    },
                    identityField: {
                        driverLicense: '',
                        socialSecurity: '',
                        monthMaidenName: '',
                        dataOfBirth: '',
                    },
                    emergency: {
                        contactName: '',
                        contactNuber: '',
                        medicalCondition: '',
                        regularMeication: '',
                        homePhone: '',
                        cellPhone: '',
                        email: '',
                    },
                    new_files: [],
                    customFields:{
                        custom_field_1:'',
                        custom_field_2:'',
                    },
                    emailExists: -1,
                },
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
            })
        },
        methods: {
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            openCropModal(){
                this.$modal.show('crop-image');
            },
            closeCropModal(){
                this.$modal.hide('crop-image');
            },
            cropImage() {
              // get image data for post processing, e.g. upload or setting image src
              this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
            },
            rotate() {
              // guess what this does :)
              this.$refs.cropper.rotate(90);
            },
            completeEdit(){
                this.finalCropImg=this.cropImg;
                this.empPersonal.new_files[0].img=this.cropImg;
                this.$modal.hide('crop-image');
                $('#imgInp').val(null);
                // console.log(this.empPersonal.new_files[0]);
            },
            addProfileImg(e) {
                // console.log(e.target.value, e.target.result);
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                     //e.target.value;
                    var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                    if (input.files[0].size < 30000000 && this.img_format.indexOf(extension) != -1) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.empPersonal.new_files[0] = {
                                // 'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report'

                            };

                        }
                        reader.readAsDataURL(input.files[0]);
                        this.openCropModal();
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                        });
                    }
                    this.onUpdateInputField();

                }
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },
            blurCellPhone(event){
                let phone=$(event.target).val();
                let patt=/^\d{10,12}$/g;
                if(!phone || patt.test(phone)|| phone==''){
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }else{
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.validation_err = 1;
                });
            },
            blurHomePhone(event){
                let phone=$(event.target).val();
                let patt=/^\d{10,12}$/g;
                if(!phone || patt.test(phone)|| phone==''){
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }else{
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                }
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.validation_err = 1;
                });
            },
            // blurCellPhone(event){
            //     if ($(event.target).val().length<10 || $(event.target).val().length>12 || !Number.isInteger(Number($(event.target).val()))) {
            //         $(event.target).siblings('.form-label').addClass('js-label-transition');
            //         this.validation_err = 1;
            //     } else {
            //         $(event.target).siblings('.form-label').removeClass('js-label-transition');
            //         this.validation_err = 0;
            //     }
            // },
            // blurHomePhone(event){
            //     if (($(event.target).val().length<10 || $(event.target).val().length>12) && $(event.target).val().length!=0 || !Number.isInteger(Number($(event.target).val()))) {
            //         $(event.target).siblings('.form-label').addClass('js-label-transition');
            //         this.validation_err = 1;
            //     } else {
            //         $(event.target).siblings('.form-label').removeClass('js-label-transition');
            //         this.validation_err = 0;
            //     }
            // },
            customValEmail(event, customEmailField) {
                if (customEmailField !== "") {
                    // const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,10}\.[0-9]{1,10}\.)|(([\w-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,10})(\]?)$/;
                    if (filter.test(customEmailField)) {
                        service.get('user/emailExists', {
                            'Authorization': this.userToken,
                            'email': this.empPersonal.contact.email,
                        }).
                        then((res) => {
                            //console.log("Email Status", res.data.result);
                            this.emailExistNote = res.data.result;
                            this.empPersonal.emailExists=res.data.result;

                        }).catch((err) => {
                            console.log(err);
                            this.emailExistNote = false;
                            this.empPersonal.emailExists=0;
                        });
                        this.onUpdateInputField();
                        $(event.target).next(".customError").css("display", "none");
                    } else {
                        $(event.target).next(".customError").css("display", "block");
                        this.empPersonal.emailExists=-1;
                    }
                } else {
                    $(event.target).next(".customError").css("display", "none");
                    this.emailExistNote = -1;
                }
            },
            emailExists() {
                //console.log("Email Status called");
                if (this.empPersonal.contact.email.length != 0) {
                    service.get('user/emailExists', {
                        'Authorization': this.userToken,
                        'email': this.empPersonal.contact.email,
                    }).
                    then((res) => {
                        //console.log("Email Status", res.data.result);
                        this.emailExistNote = res.data.result;

                    }).catch((err) => {
                        console.log(err);
                        this.emailExistNote = false;
                    });
                } else {
                    this.emailExistNote = -1;
                }
                this.onUpdateInputField();

            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                bus.$emit('onUpdatePersonalDetails', this.empPersonal);
                //                if ($(event.target).val() === "") { // $(event.target).siblings('.form-label').addClass('js-label-transition'); // } else { // $(event.target).siblings('.form-label').removeClass('js-label-transition'); // }
            }

        },
        created() {
            this.empPersonal = this.empPersonalData;
            //console.log(this.empPersonalData);
            service.get('client/'+this.userClientID, {
                'Authorization': this.userToken
            }).
            then((res) => {
                //console.log("Job details", res.data.result);
                this.custom_field_1=res.data.result.custom_field_1;
                this.custom_field_2=res.data.result.custom_field_2;
            }).catch((err) => {
                console.log(err);
            });
        },
        mounted() {
            let self=this;
            $(document).on('change', '.btn-file :file', function() {
                var input = $(this),
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger('fileselect', [label]);
            });

            $('.btn-file :file').on('fileselect', function(event, label) {
                var input = $(this).parents('.input-group').find(':text'),
                    log = label;
                if (input.length) {
                    input.val(log);
                } else {
                    if (log) alert(log);
                }
            });

            function readURL(input) {

                var extension=input.files[0].name.split(".")[input.files[0].name.split(".").length-1];
                if (input.files && input.files[0] && input.files[0].size < 30000000 && self.img_format.indexOf(extension) != -1) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        // $('#img-upload').attr('src', '');
                        self.cropImg='';
                        self.cropableImg=e.target.result;
                        self.$refs.cropper.replace(e.target.result);

                        var type = input.files[0].type.split("/");
                        self.empPersonal.new_files[0] = {
                            // 'img': img,
                            'name': input.files[0].name,
                            'status': true,
                            'uploading': false,
                            'uploaded': false,
                            'path': '',
                            'type': type[0],
                            'progress': 0,
                            'label': 'Report'
                        };

                        setTimeout(()=>{
                            self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();
                        },1000)
                    }
                    reader.readAsDataURL(input.files[0]);
                }else {
                    self.$notify.error({
                        title: this.$t('error'),
                        message: 'Image size should be less than 30 MB and format should be jpg, jpeg, png and gif'
                    });
                }
                
                self.onUpdateInputField();
            }

            $("#imgInp").change(function() {
                readURL(this);
            });

            setTimeout(()=>{
                // console.log('hiiii');
                this.$validator.validateAll().then((result)=>{
                    if(result)
                        this.validation_err = 0;
                    else
                        this.validation_err = 1;
                });
            },2000);
        }
    }

</script>
<style scoped>
.crop-image-top-margin{
    margin-top: 15px;
}

</style>
